<div [ngClass]="styleWrapper || 'footer-wrapper'">
  <div *ngIf="infoLabel && infoLabel !== ''" [ngClass]="styleLabel || 'label-wrapper'">{{ infoLabel }}</div>
  <div *ngIf="tempArray && tempArray.length > 0" [ngClass]="styleContainer || 'btn-container'">
    <ng-container *ngFor="let btn of tempArray">
      <button
        *ngIf="btn.type === 'outline'"
        (click)="changeComponent(btn.label)"
        mat-stroked-button
        color="primary"
        class="m-0">
        {{ btn.label | translate }}
      </button>

      <button
        *ngIf="btn.type === 'flat'"
        (click)="changeComponent(btn.label)"
        mat-flat-button
        color="primary"
        class="me-2">
        {{ btn.label | translate }}
      </button>
    </ng-container>
  </div>
</div>
